import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Card from "../components/card"
import CasePosts from "../components/casePosts"
import TrendPosts from "../components/trendPosts"
import FeaturedPosts from "../components/featuredPosts"
import SectionTitle from "../components/sectionTitle"
import LinkButton from "../components/linkButton"
import Container from "../components/container"
import StaticTagList from "../components/staticTagList"
import Sidebar from "../components/sidebar"

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const posts = data.allMarkdownRemark.nodes

  if (posts.length === 0) {
    return (
      <Layout location={location}>
        <Seo title="DX BLOG｜株式会社EVERRISE" isHome={true} />
        <p>
          No blog posts found. Add markdown posts to "content/blog" (or the
          directory you specified for the "gatsby-source-filesystem" plugin in
          gatsby-config.js).
        </p>
      </Layout>
    )
  }

  return (
    <Layout location={location}>
      <Seo title="DX BLOG｜株式会社EVERRISE" isHome={true} />
      <FeaturedPosts />
      <Container className="lg:flex justify-between mt-5 lg:mt-12">
        <div className="lg:w-2/3 pb-10">
          <SectionTitle
            title="最新記事"
            bgText="Recent Posts"
            className="mb-6"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7">
            {posts.map(post => (
              <Card post={post} size="m" key={post.id} />
            ))}
          </div>
          <div className="flex justify-center p-6 lg:p-7">
            <LinkButton text="READ MORE" url="/1/" />
          </div>
        </div>
        <div className="lg:w-1/4">
          <Sidebar banner={[4, 1]} />
        </div>
      </Container>
      <Container className="">
        <SectionTitle title="記事を探す" bgText="Search" className="mb-6" />
        <StaticTagList tagType="category" className="mb-4 lg:mb-7" />
        <StaticTagList tagType="assignment" className="mb-4 lg:mb-7" />
        <StaticTagList tagType="marketing-measures" className="mb-4 lg:mb-7" />
        <StaticTagList tagType="tools-channel" className="mb-4 lg:mb-7" />
        <StaticTagList tagType="industry" className="mb-4 lg:mb-7" />
      </Container>
      <Container className="lg:mt-12 lg:mb-12">
        <SectionTitle
          title="導入・開発事例"
          bgText="Case Study"
          className="mb-6"
        />
        <CasePosts />
      </Container>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 6
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { meta: { draft: { eq: false } } } }
    ) {
      nodes {
        fields {
          meta {
            slug
          }
        }
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          description
          tags
          cover {
            childImageSharp {
              gatsbyImageData(width: 800, formats: AUTO)
            }
          }
        }
        id
      }
    }
  }
`
